import React from 'react';

export const ValidateError = ({ type, children }) => {
  return <div className={`validation-error ${type}`}>{children}</div>;
};
